import axios from 'axios';
import React, { KeyboardEvent, useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import homeState from '../../../atoms/home';
import messagesState from '../../../atoms/messages';
import myInfoState from '../../../atoms/myinfo';
import participantsState from '../../../atoms/participants';
import userDetailsState from '../../../atoms/userDetails';
import { getUser } from '../../../connector';
import emitGetUserDetails from '../../../connector/emits/getUserDetails';
import emitSendMessage from '../../../connector/emits/sendMessage';
import { MessageType, SystemMessageType } from '../../../connector/type';
import PlainMessage from '../../Room/Chatting/PlainMessage';
import SystemMessage from '../../Room/Chatting/SystemMessage';
import './HomeChatting.scoped.scss'
import inchatNoticeContentsState from '../../../atoms/inchatNoticeContents';

function getScrolledPercent(element: HTMLElement) {
  if (element == null) {
    return 0;
  }
  const scrollRange = element.scrollHeight - element.offsetHeight;
  return Math.round((element.scrollTop / scrollRange) * 100);
}

function HomeChatting() {
  // Recoil
  const [inchatNoticeContents, setInchatNoticeContents] = useRecoilState(inchatNoticeContentsState);
  const [myInfo] = useRecoilState(myInfoState);
  const [home] = useRecoilState(homeState);
  const [participants] = useRecoilState(participantsState);
  const [userDetails] = useRecoilState(userDetailsState);
  const [messages] = useRecoilState(messagesState);

  // Local state
  const [hasFirstScrolled, setHasFirstScrolled] = useState(false);
  const [message, setMessage] = useState('');
  const [lastScrolledPercent, setLastScrolledPercent] = useState(0);
  const messagesReference = useRef<HTMLDivElement>(null);
  const noticesUlRef = useRef<HTMLUListElement>(null);
  const [notices, setNotices] = useState<unknown>([]);

  const isGuest = myInfo.userDetail?.id == null || myInfo.userDetail?.id === '';

  // Effect
  useEffect(() => {
    setTimeout(() => {
      if (messagesReference.current != null) {
        messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
        setLastScrolledPercent(100);
      }
      messagesReference.current?.addEventListener('scroll', (event) => {
        if (messagesReference.current == null) {
          return;
        }
        setLastScrolledPercent(getScrolledPercent(messagesReference.current));
      });
    }, 500);
    (async () => {
      const noticesRes = await axios.get('/chat/get_notice.php');
      setNotices(noticesRes.data);

      const inchatNoticeRes = await axios.get('/chat/inchat_notice.php');
      setInchatNoticeContents(inchatNoticeRes.data as string);
    })();
  }, []);

  useEffect(() => {
    if ((notices as unknown[]).length > 0) {
      (function () {
        let noticesSequance = 0;
        setInterval(() => {
          if (noticesUlRef.current == null) {
            return;
          }
          ++noticesSequance;
          const noticesUl = noticesUlRef.current;
          noticesUl.style.marginLeft = `-${(noticesSequance) * 100}vw`;
          if (noticesSequance === (notices as unknown[]).length) {
            setTimeout(() => {
              noticesUl.style.transition = 'none';
              noticesUl.style.marginLeft = '0vw';
              noticesSequance = 0;
              setTimeout(() => {
                noticesUl.style.transition = 'all 1s';
              }, 100);
            }, 1000);
          }
        }, 5000);
      })();
    }
  }, [notices]);

  useEffect(() => {
    emitGetUserDetails(participants.users);
  }, [participants.users]);

  useEffect(() => {
    if (messagesReference.current == null) {
      return;
    }
    if (!hasFirstScrolled && messages.messages.length > 0) {
      setHasFirstScrolled(true);
      messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
      return;
    }
    if (lastScrolledPercent === 100 || lastScrolledPercent === 99) {
      messagesReference.current.scrollTop = messagesReference.current.scrollHeight;
    }
  }, [hasFirstScrolled, lastScrolledPercent, messages]);

  // Event
  const onKeyPressnput = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  // Handle
  const sendMessage = () => {
    if (message.length === 0) {
      return;
    }
    emitSendMessage('square', {
      user: getUser(),
      messageType: MessageType.PLANE,
      contents: message,
    });
    setMessage('');
  }

  return (
    <div className="home-chatting-shell">
      <div 
        ref={messagesReference}
        className="home-chatting-messages"
        style={{ fontSize: home.fontSize }}
      >
        {
          messages.roomId === 'square'
            ? messages.messages.map((message, index) => {
              if (message.messageType === MessageType.SYSTEM) {
                const contents = message.contents as { systemMessageType: SystemMessageType };
                if (contents.systemMessageType === SystemMessageType.JOIN_USER) {
                  return null;
                }
                return (
                  <SystemMessage
                    key={index}
                    userId={message.user} 
                    userDetail={userDetails.get(message.user)}
                    contents={contents}
                  />
                );
              }
              return (
                <PlainMessage 
                  key={index}
                  userId={message.user} 
                  userDetail={userDetails.get(message.user)}
                  contents={message.contents as string}
                />
              );
            })
            : null
        }
      </div>
      <div className="home-chatting-input">
        <input 
          type="text" 
          placeholder={!isGuest ? '메시지 입력' : '로그인 후 이용해주세요.'}
          disabled={isGuest}
          id="chat_input" 
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={onKeyPressnput} 
        />
        <button type="button" onClick={sendMessage} disabled={isGuest || message.length === 0}>전송</button>
      </div>
    </div>
  );
}

export default HomeChatting;
